'use client'

import { APIProvider } from '@vis.gl/react-google-maps'
import { ReactNode } from 'react'

const MAPS_LIBRARIES: string[] = ['marker']

export const MAPS_INTEGRATION_ID = 'maps'

export const MapsApiProvider = ({ children }: { children?: ReactNode }) => (
    <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_API_KEY ?? ''} libraries={MAPS_LIBRARIES}>
        {children}
    </APIProvider>
)
